import { motion, useTime, useTransform } from "framer-motion";

export const LoadingCircles = () => {
  const time = useTime();
  const rotate = useTransform(
    time,
    [0, 4000], // For every 4 seconds...
    [0, 360], // ...rotate 360deg
    { clamp: false },
  );

  return (
    <motion.div
      data-cy="loading-circles"
      className="flex justify-center items-center w-full   gap-4 pb-8"
    >
      <motion.div
        className=" bg-superscriptBlue w-5 h-5 rounded-full"
        animate={{
          y: [10, -50, 10],
          scale: [1, 0.3, 1],
          x: [0, 30, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
        }}
      />
      <motion.div
        className=" bg-superscriptBlue w-5 h-5 rounded-full"
        animate={{
          y: [5, -55, 5],
          scale: [1, 0.3, 1],
          x: [0, 10, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          delay: 0.1,
        }}
      />
      <motion.div
        className=" bg-superscriptBlue w-5 h-5 rounded-full"
        animate={{
          y: [0, -60, 0],
          scale: [1, 0.3, 1],
          x: [0, -10, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          delay: 0.2,
        }}
      />
      <motion.div
        className=" bg-superscriptBlue w-5 h-5 rounded-full"
        animate={{
          y: [-5, -65, -5],
          scale: [1, 0.3, 1],
          x: [0, -30, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          delay: 0.3,
        }}
      />
    </motion.div>
  );
};
